import React from 'react';
import { useParams } from 'react-router-dom';

const UpdateEvent = () => {
    const { id } = useParams();
    return (
        <div>
            update {id}
        </div>
    );
};

export default UpdateEvent;